'use client'
import 'vanilla-cookieconsent'
import { useEffect } from 'react'
import cCConfig from 'config/cookies'
import 'vanilla-cookieconsent/dist/cookieconsent.css'

const CookieConsent = () => {
  useEffect(() => {
    /**
     * useEffect is executed twice (React 18+),
     * make sure the plugin is initialized and executed once
     */
    if (!document.getElementById('cc--main')) {
      window.CookieConsentApi = window.initCookieConsent()
      window.CookieConsentApi.run(cCConfig)
    }
  }, [])

  return null
}

export default CookieConsent
